import styled from 'styled-components'

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25rem;

	padding: 1rem 1rem;
	border-radius: 1rem;
	background-color: #f3f3f3;
`
